import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Select, Divider, Button, List } from "antd";
import { createBranch, updateBranch, listBranchProducts, setBranchProduct } from "../../services/branch";
import { getProducts } from "../../services/product";
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';


const confirm = Modal.confirm;
const { Option } = Select;

class BranchFormModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disableOkButton: false,
            branchProducts: [],
            selectedAddProductId: undefined,
            productChoices: [],
            allProducts: []
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.prepareForm = this.prepareForm.bind(this);
        this.formRef = React.createRef();
        this.getBranchProductData = this.getBranchProductData.bind(this)
        this.filterProductChoices = this.filterProductChoices.bind(this)
        this.onProductSelected = this.onProductSelected.bind(this)
        this.onBranchProductDeleteClick = this.onBranchProductDeleteClick.bind(this)
        this.getProductChoices = this.getProductChoices.bind(this)
    }

    async onFormSubmit() {
        const { data, editing, setVisible, reloadData, reloadAfterCreate } = this.props;
        const { branchProducts } = this.state
        await this.setState({
            disableOkButton: true
        })
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }

        if (passed) {
            if (!editing) {
                await createBranch(values)
                reloadAfterCreate();
            }
            else {
                await updateBranch(data['id'], values)
                const productIds = branchProducts.map(bp => bp.product.id)
                await setBranchProduct(data['id'], productIds)
                reloadData();
            }
            setVisible(false);
        }
        this.setState({
            disableOkButton: false
        })

    };

    async getProductChoices() {
        const res = await getProducts("", { "product.is_active": true }, 1, 1000000, "name", "ASC")
        this.setState({
            allProducts: res.data.products
        })
    }

    async filterProductChoices() {
        const { branchProducts, allProducts } = this.state
        // Remove choices that same as user branch
        const productChoices = []
        for (let i = 0; i < allProducts.length; i++) {
            let dupe = false
            for (let j = 0; j < branchProducts.length; j++) {
                if (branchProducts[j].product.id === allProducts[i].id) {
                    dupe = true
                }
            }
            if (!dupe) {
                productChoices.push(allProducts[i])
            }
        }
        this.setState({
            productChoices,
            selectedAddProductId: undefined
        })
    }

    async getBranchProductData() {
        const { data } = this.props
        const res = await listBranchProducts(data.id)
        this.setState({
            branchProducts: res.data.branch_products
        })
    }

    async onProductSelected(selectedProductId) {
        const { branchProducts, productChoices } = this.state
        const { data } = this.props
            const selectedProduct = productChoices.filter(p =>
                {
                    return selectedProductId === p.id;
                })
            branchProducts.push({product: selectedProduct[0]})
            this.filterProductChoices()
            this.setState({
                selectedProductId
            }, ()=> {
                this.setState({selectedProductId: undefined})
            })
    }

    onBranchProductDeleteClick(row) {
        const { branchProducts } = this.state
        for (let i = 0; i<branchProducts.length; i++){
            if (branchProducts[i].id === row.id){
                branchProducts.splice(i, 1);
            }
        }
        this.setState({
            branchProducts
        }, () => {
            this.filterProductChoices()
        })
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    async prepareForm() {
        await this.getBranchProductData()
        await this.getProductChoices()
        await this.filterProductChoices()
    }

    render() {
        const { editing, visible, setVisible, data } = this.props;
        const { disableOkButton, productChoices, branchProducts, selectedAddProductId } = this.state;

        return (
            <Modal
                visible={visible}
                onCancel={() => { setVisible(false) }}
                onOk={this.onFormSubmit}
                title={editing ? "แก้ไขรายการ" : "เพิ่มรายการ"}
                okText={editing ? "แก้ไข" : "เพิ่ม"}
                cancelText={"ปิด"}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
                okButtonProps={{ disabled: disableOkButton }}
            >
                <Form
                    ref={this.formRef}
                    layout={'vertical'}
                    initialValues={data}
                >
                    <Row gutter={12}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                            <Form.Item
                                hasFeedback
                                label="รหัสสาขา"
                                name="code"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่รหัสสาขา"
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อสาขา"
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาใส่ชื่อสาขา"
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="หมายเหตุอื่นๆ"
                                name="description"
                                rules={[]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    {editing && <div>
                        <Divider orientation="center">สินค้าที่ขาย</Divider>
                        <Row>
                            <Col span={8} xs={6} sm={6} md={8} lg={8} xl={8} xxl={8}/>
                            <Col span={10} xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                                <Select
                                    style={{ width: '100%', marginBottom: 10 }}
                                    placeholder="เลือกสินค้าที่ต้องการเพิ่ม"
                                    optionFilterProp="children"
                                    onSelect={e => this.onProductSelected(e)}
                                >
                                    {productChoices.map(bc =>
                                        <Option key={bc.id} value={bc.id}>{bc.name}</Option>
                                    )}
                                </Select>
                            </Col>
                            {/* <Col span={1} offset={1}>
                                <Button
                                    style={{ float: 'right' }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={this.onProductSelected}
                                />
                            </Col> */}
                        </Row>
                        <Row>
                            <Col xs={0} sm={0} md={6} lg={6} xl={6} xxl={6}/>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                                <List
                                    bordered
                                    dataSource={branchProducts}
                                    renderItem={item => (
                                        <List.Item
                                            actions={[<Button
                                                color="danger"
                                                variant="solid"
                                                shape="circle"
                                                size="small"
                                                icon={<DeleteOutlined />}
                                                onClick={() => this.onBranchProductDeleteClick(item)}
                                            />]}
                                        >
                                            {item.product.name}
                                        </List.Item>
                                    )}
                                />
                            </Col>
                        </Row>
                    </div>}
                </Form>
            </Modal>
        );
    }
}

export default BranchFormModal;